import styled from 'styled-components'

export const StyledKCSA = styled.div`
  .statement {
    margin: 0 0 1.5rem;
    padding: 0;
  }

  .question-metadata {
    align-items: center;
    display: flex;
    flex-direction: column;
    justify-content: center;

    @media screen and (min-width: 31.25em) {
      flex-direction: row;
      justify-content: space-between;
    }

    p {
      font-size: 80%;
      margin: 1rem 0;
    }

    div {
      align-items: center;
      display: flex;
      flex-direction: column;
      justify-content: center;

      button {
        margin-bottom: 0.5rem;
      }

      @media screen and (min-width: 31.25em) {
        flex-direction: row;

        > button {
          margin: 0 0 0 0.5rem;
        }
      }
    }
  }

  input[type='radio'] {
    display: none;
  }

  input:focus + label {
    background-color: var(--color-gray-800);
  }

  label {
    align-items: center;
    border: 1px solid var(--color-gray-500);
    border-radius: 4px;
    display: flex;
    line-height: 1.3;
    margin-bottom: 0.5rem;
    padding: 0.75rem;
    transition: background-color 0.1s ease;
    width: 100%;

    @media screen and (min-width: 64em) {
      background-size: auto;
    }

    @media (any-hover: hover) {
      &:hover {
        background-color: #f5f5f5;
        cursor: pointer;
      }
    }

    &:active {
      background-color: rgb(230, 230, 230);
    }

    @keyframes glow {
      0% {
        box-shadow: 0 0 0 var(--color-blue-700);
      }
      50% {
        box-shadow: 0 0 12px var(--color-blue-700);
      }
      100% {
        box-shadow: 0 0 0 var(--color-blue-700);
      }
    }

    &.cheater {
      animation: 3000ms ease-in-out infinite glow;
    }
  }

  input[type='radio']:checked + label {
    border-color: var(--color-blue-400);

    &.error {
      border-color: var(--color-red-400);
    }

    &.success {
      background-color: var(--color-green-400);
      border-color: var(--color-green-400);
      color: var(--color-white);
    }
  }

  input[disabled] + label {
    &:hover {
      background-color: white;
      cursor: default;
    }
  }

  --image-size: 15.625rem;

  .image-grid-items {
    display: grid;
    gap: 1.5rem;
    grid-template-columns: repeat(2, 1fr);
    justify-content: center;
    margin: 0 auto;
    max-width: 500px;

    @media screen and (min-width: 64em) {
      grid-template-columns: repeat(4, 1fr);
      max-width: 1000px;
    }
  }

  .image-grid-item {
    label {
      border-radius: var(--radius);
      border: 6px solid transparent;
      display: flex;
      justify-content: center;
      margin: 0;
      /* object-fit: cover; */
      overflow: hidden;
      padding: 0;
      transition: transform 225ms ease-in-out;

      &:hover,
      &:focus {
        transform: translateY(-0.5rem);
      }

      img {
        border-radius: var(--radius);
      }
    }

    input[type='radio']:checked + label {
      border: 6px solid var(--color-blue-700);
      border-radius: 24px;
      transform: translateY(-0.5rem);
    }
  }
`
